import { SvgIcon } from "@mui/material";
import { OpenAI, Anthropic, Mistral, Cohere } from "@lobehub/icons";
import Docker from "mdi-react/DockerIcon";

export const OpenAIIcon = props => (
  <SvgIcon component={OpenAI} inheritViewBox {...props} />
);

export const AnthropicIcon = props => (
  <SvgIcon component={Anthropic} inheritViewBox {...props} />
);

export const MistralIcon = props => (
  <SvgIcon component={Mistral} inheritViewBox {...props} />
);

export const CohereIcon = props => (
  <SvgIcon component={Cohere} inheritViewBox {...props} />
);

export const DockerIcon = props => (
  <SvgIcon component={Docker} inheritViewBox {...props} />
);
